<template>
  <div ref="modal" class="modal fade customer-property-edit-popup" tabindex="-1" role="dialog" :id="id">
        <div class="modal-dialog" role="document">
            <validation-observer ref="form">
                <form @submit.prevent="submit">
                    <div class="modal-content">
                        <div class="modal-header new-design">
              <h5 class="modal-title"> Edit {{ propertyName | escapeSpecailCharacterInPropertyName }}</h5>
              <div class="close-icon clickable" data-dismiss="modal" aria-label="Close">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                                        fill="#03A9F4"/>
                                </svg>
                            </div>
                        </div>
                        <div class="modal-body">

                            <div class="col-md-12 text-center">
                                <span v-if="formLoading"><i class="fa fa-spinner fa-spin"></i> Loading...</span>
                            </div>

              <div class="col-md-12" v-for="(field,index) of form" :key="index">
                                <!-- Text Box -->
                <validation-provider :rules="field.is_required? 'required' : ''"
                                                     :name="field.property_field_name"
                                     v-if="field.type == getFieldType('text')"
                                     v-slot="{errors}">
                                    <div :class="{'form-group':true,'has-error':errors.length}">
                                        <div class="input-container">

                      <textarea v-if=" field.property_field_name == 'Description'"
                                class="form-control new-design"
                                :name="field.property_field_name"
                                :placeholder="field.property_field_name"
                                v-model="field.value"></textarea>

                    <input v-else type="text" class="form-control new-design is-valid"
                           :name="field.property_field_name"
                                                   :placeholder="field.property_field_name"
                           v-model="field.value">

                                            <label>{{ field.property_field_name }}</label>
                                        </div>
                                        <span class="text text-danger error-label">{{ errors[0] }}</span>
                                    </div>
                                </validation-provider>

                                <!-- Number Box -->
                <validation-provider :rules="field.is_required? 'required' : ''"
                                     :name="field.property_field_name"
                                     v-else-if="field.type == getFieldType('number')"
                                     v-slot="{errors}">
                                    <div :class="{'form-group':true,'has-error':errors.length}">
                                        <div class="input-container">
                    <input class="form-control new-design is-valid" type="number"
                           :name="field.property_field_name"
                                                   :placeholder="field.property_field_name"
                           v-model="field.value">
                                            <label>{{ field.property_field_name }}</label>
                                        </div>
                                        <span class="text text-danger error-label">{{ errors[0] }}</span>
                                    </div>
                                </validation-provider>

                                <!-- Date Picker -->
                <validation-provider :rules="field.is_required? 'required' : ''"
                                     :name="field.property_field_name"
                                     v-else-if="field.type == getFieldType('date')"
                                     v-slot="{errors}">
                                    <div :class="{'form-group':true,'has-error':errors.length}">
                                        <div class="input-container">
                    <date :placeholder="field.property_field_name" class="is-valid"
                                                  :name="field.property_field_name"
                          :date-format="dateFormat"
                          v-model="field.value"></date>
                                            <label>{{ field.property_field_name }}</label>
                                        </div>
                                        <span class="text text-danger error-label">{{ errors[0] }}</span>
                                    </div>
                                </validation-provider>

                <!-- List Select -->
                <validation-provider :rules="field.is_required? 'required' : ''"
                                     :name="field.property_field_name"
                                     v-else-if="field.type == getFieldType('list')"
                                     v-slot="{errors}">
                                    <div :class="{'form-group':true,'has-error':errors.length}">
                                        <div class="input-container">
                    <select-list :name="field.property_field_name" class="is-valid"
                                 :selected="field.property_field_value_id"
                                                         :placeholder="field.property_field_name"
                                 v-model="field.value" :options="field.options"></select-list>
                                            <label>{{ field.property_field_name }}</label>
                                        </div>
                                        <span class="text text-danger error-label">{{ errors[0] }}</span>
                                    </div>
                                </validation-provider>

                                <!-- Checkboxes -->
                <validation-provider :rules="field.is_required? 'atLeastOneOptionSelected' : ''"
                                     :name="field.property_field_name"
                                     v-else-if="field.type == getFieldType('checkbox')"
                                     v-slot="{errors}">
                                    <div :class="{'form-group':true,'has-error':errors.length}">
                    <check-boxes v-model="field.options" :selected="field.value"
                                                     :placeholder="field.property_field_name"
                                 :options="field.options"></check-boxes>
                                        <span class="text text-danger error-label">{{ errors[0] }}</span>
                                    </div>
                                </validation-provider>

                <!-- Address -->
                <validation-provider :rules="field.is_required? 'required' : ''"
                                     :name="field.property_field_name"
                                     v-else-if="field.type == getFieldType('address')"
                                     v-slot="{errors}">
                                    <div :class="{'form-group':true,'has-error':errors.length}">
                                        <div class="input-container">
                    <address-input v-model="field.value" :country-code="countryCode" class="is-valid"
                                   :placeholder="field.property_field_name"></address-input>
                                            <label>{{ field.property_field_name }}</label>
                                        </div>
                                        <span class="text text-danger error-label">{{ errors[0] }}</span>
                                    </div>
                                </validation-provider>


                                <!-- Email -->
                <validation-provider :rules="field.is_required? 'required' : ''"
                                     :name="field.property_field_name"
                                     v-else-if="field.type == getFieldType('email')"
                                     v-slot="{errors}">
                                    <div :class="{'form-group':true,'has-error':errors.length}">
                                        <div class="input-container">
                    <email-input v-model="field.value" class="is-valid"
                                 :placeholder="field.property_field_name"></email-input>
                                            <label>{{ field.property_field_name }}</label>
                                        </div>
                                        <span class="text text-danger">{{ errors[0] }}</span>
                                    </div>
                                </validation-provider>

                <!-- Phone -->
                <validation-provider :rules="field.is_required? 'required' : ''"
                                     :name="field.property_field_name"
                                     v-else-if="field.type == getFieldType('phone')"
                                     v-slot="{errors}">
                                    <div :class="{'form-group':true,'has-error':errors.length}">
                                        <div class="input-container">
                    <phone-input v-model="field.value" class="is-valid"
                                 :placeholder="field.property_field_name"></phone-input>
                                            <label>{{ field.property_field_name }}</label>
                                        </div>
                                        <span class="text text-danger error-label">{{ errors[0] }}</span>
                                    </div>
                                </validation-provider>

                  <!-- Image -->
                  <validation-provider :rules="field.is_required? 'required' : ''"
                                       :name="field.property_field_name"
                                       v-else-if="field.type == getFieldType('image')"
                                       v-slot="{errors}">
                      <div :class="{'form-group':true,'has-error':errors.length}">
                          <image-input v-model="field.value"
                                       :placeholder="field.property_field_name"></image-input>
                          <span class="text text-danger error-label">{{ errors[0] }}</span>
                      </div>
                  </validation-provider>

                  <!-- Toggle -->
                  <validation-provider :rules="field.is_required ? 'required' : ''"
                                       :name="field.property_field_name"
                                       v-else-if="field.type == getFieldType('toggle')"
                                       v-slot="{errors}">
                      <div :class="{'m-b--20':true,'form-group':true,'has-error':errors.length}">
                          <toggle-switch
                              v-model="field.value" :placeholder="field.property_field_name"
                                         :label="field.label"></toggle-switch>
                          <span class="text text-danger error-label">{{ errors[0] }}</span>
                      </div>
                  </validation-provider>

              </div>
            </div>
            <div class="modal-footer new-design">
              <div class="col-md-12">
                <button type="submit" class="btn btn-primary new-design" :disabled="loading"
                        :class="{disabled:loading}">
                  <span v-if="!loading">Save</span>
                  <span v-else><i class="fa fa-spinner fa-spin"></i> Loading...</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import {getCustomerProperty, updateCustomerProperty} from '@/modules/CustomerProperties/api'
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required, email} from 'vee-validate/dist/rules';
import moment from 'moment'
import {atLeastOneOptionSelected, verifyPhoneNumbers} from '@/modules/Fields/validations'
import {EventBus} from "@/events/event-bus";


email.message = 'This is invalid email'
required.message = 'This field is required'

extend('email', email);
extend('required', required);
extend('atLeastOneOptionSelected', atLeastOneOptionSelected)


const PROPERTY_FIELD_TYPES = {
  "toggle": 10,
  "image": 9,
  "phone": 8,
  "email": 7,
  "address": 6,
  "checkbox": 5,
  "list": 4,
  "date": 3,
  "number": 2,
  "text": 1,
}

export default {
  name: "CustomerPropertyEditPopup",
  props: {
    id: {
      required: true
    },
    propertyId: {
      required: true
    },
    propertyName: {
      required: true
    },
    customerPropertyId: {
      required: true
    },
    countryCode: {
      required: true
    },
      countryKey: {
          required: true
      },
    dateFormat: {
      required: true
    },
    customerId: {
      required: true
        },
      reloadPage: {
          required: false,
          default:false
      }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      form: [],
            loading: false,
            formLoading: false
        }
    },
    computed: {
        formData() {
            return {
                customer_id: this.customerId,
                reload: 0,
        property_id: this.propertyId,
        data: this.form.map(field => {
                    let value
                    if (field.type == PROPERTY_FIELD_TYPES['checkbox']) {
                        value = field.options.filter(option => option.selected)
                            .map(option => option.property_field_value_id)
                            .join(',')
                    } else if (field.type == PROPERTY_FIELD_TYPES['date']) {
                        value = moment(field.value).format('YYYY-MM-DD')
                    } else {
                        value = field.value
                    }
            /** related path ??  controllers/IndexController.php ?? savePropertyFieldsAction()
             * BookingPropertyEditPopup.vue ,,,  CustomerPropertyEditPopup.vue  **/
                    if (field.customer_property_field_value_id) {
                        return {
                            is_option: +(field.type == PROPERTY_FIELD_TYPES['list']),
                            is_checkbox: +(field.type == PROPERTY_FIELD_TYPES['checkbox']),
                            is_address: +(field.type == PROPERTY_FIELD_TYPES['address']),
                            is_image: +(field.type == PROPERTY_FIELD_TYPES['image']),
                            field_id: field.property_field_id,
                            field_value: value,
              customer_property_field_value_id: field.customer_property_field_value_id,
              is_common: field.is_common

                        }
                    } else {
                        return {
                            is_option: +(field.type == PROPERTY_FIELD_TYPES['list']),
                            is_checkbox: +(field.type == PROPERTY_FIELD_TYPES['checkbox']),
                            is_address: +(field.type == PROPERTY_FIELD_TYPES['address']),
                            is_image: +(field.type == PROPERTY_FIELD_TYPES['image']),
                            field_id: field.property_field_id,
                            field_value: value,
              is_common: field.is_common

                        }
                    }
        }),
                customer_property_id: this.customerPropertyId
            }
        },
        phoneNumbers() {
      return this.form.filter(field => field.type == PROPERTY_FIELD_TYPES['phone']).map(field => field.value)
        },
        phoneNumberFields() {
      return this.form.filter(field => field.type == PROPERTY_FIELD_TYPES['phone'])
        }
    },
    methods: {
        submit() {
            this.loading = true
            this.$refs.form.validate()
                .then(async success => {
                    if (!success) {
                        this.loading = false
                        return;
                    }
                    if(this.customerId == null || this.customerId == 'undefined'){
                        this.customerId = document.getElementById('customer_id').value;
                    }

                    if (this.phoneNumbers && this.phoneNumbers[0]) {
                        verifyPhoneNumbers(this.phoneNumbers, this.countryKey)
                            .then(async data => {
                                if (!data.is_valid) {
                                    let errors = {};
                                    for (let key in data) {
                                        if (!['messages', 'is_valid'].includes(key) && this.phoneNumberFields.length > 0) {
                                            let fieldName = this.phoneNumberFields[key].property_field_name
                                            errors[fieldName] = [data[key]]
                                        }
                                    }

                                    this.$refs.form.setErrors(errors)
                                    this.loading = false

                                    return;
                                }

                                let response = await updateCustomerProperty(this.formData)

                                EventBus.$emit('onCustomerPropertyUpdated', response.data)

                                $(this.$refs['modal']).modal('toggle')
                                this.loading = false
                              if (this.reloadPage){
                              window.location.reload();
                              }
                            })
                        return;
                    }

                    let response = await updateCustomerProperty(this.formData)

              EventBus.$emit('onCustomerPropertyUpdated', response.data)

                    $(this.$refs['modal']).modal('toggle')
                    this.loading = false
                  if (this.reloadPage) {
                      window.location.reload();
                  }
                })
        },
        getForm() {
      getCustomerProperty(this.customerPropertyId, this.propertyId)
                .then(response => {
                    let form = response.data;
                    for (let field of form) {
                        if (field.value != null) {
                            field.value = field.value.replace(/&amp;/g, '&');
                        }
                    }
            this.form = response.data.sort((first, second) => {
                        if (first.order < second.order) {
                            return -1;
                        } else if (first.order > second.order) {
                            return 1;
                        } else {
                            return 0;
                        }
                    })
                    this.formLoading = false
                    this.loading = false
                })
        },
        getFieldType(name) {
            return PROPERTY_FIELD_TYPES[name];
        },
        listenOnPopupToggle() {
            $(this.$refs['modal']).on('shown.bs.modal', (e) => {
        this.form = []
                this.formLoading = true
                this.loading = true
                this.getForm();
            })
        },
    },
    filters: {
        escapeSpecailCharacterInPropertyName: function (value) {
            if (!value) return ''
            let decoded = value.replace(/&amp;/g, '&');
            return decoded
        }
    },
    mounted() {
        this.listenOnPopupToggle()
    }
}
</script>

<style scoped>

.modal-header.new-design {
  border-bottom: unset;
}

.has-error .form-control {
  border-color: #a94442 !important;
}

.modal-header.new-design .modal-title {
  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  color: #2E4051;
  display: inline;
}

.modal-footer.new-design {
    border-top: unset;
}

.close-icon {
    float: right;
}

.clickable {
  cursor: pointer;
}

.error-label {
  top: 8px;
  position: relative;
}

.btn.new-design {
  border-radius: 8px;
  padding: 12px 16px;
  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  color: #FFFFFF;
}

.btn-primary.new-design {
  background: #2E4051 !important;
}

.form-control.new-design::placeholder {
  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.form-control.new-design {
  padding: 16px;
  border: 1px solid #E0E2E5;
  border-radius: 8px;
  box-sizing: border-box;

  height: 56px;

  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.form-loading {

}
label {
    display: block;
    position: absolute;
    top: 30%;
    transform: translateY(-50%);
    left: 32px;
    color: #2E4051;
    transform-origin: left top;
    user-select: none;
    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1), color 150ms cubic-bezier(0.4, 0, 0.2, 1), top 500ms;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
}

.form-control.new-design {
    padding-top: 30px !important;
}

input:focus + label,
input.is-valid + label {
    transform: translateY(-100%) scale(0.75);
}

.date-icon, .phone-icon, .email-icon, .address-icon {
    background-position-y: 25px !important;
}

@media (max-width: 768px) {
    .m-b--20 {
        margin-bottom: -20px;
    }
}

</style>